export default [
  {
    header: 'MANAGE'
  },
  {
    title: 'Creative Hub',
    icon: 'CreativeHubIcon',
    route: {name: 'manage-creativeHub', params: {pageType: 'creative-hub'}},
  },
  {
    title: 'Plan',
    icon: 'PlanIcon',
    route: 'manage-plan'
  },
  {
    title: 'Buy',
    icon: 'BuyIcon',
    route: '',
    disabled: true
  },
  {
    title: 'Optimize',
    icon: 'OptimizeIcon',
    route: 'manage-smartOptimization'
  }
]
